export const assignAllText = {
	assignEntirely: 'Assign entirely',
	groupAll: 'Group all',
	ungroupAll: 'Ungroup all',
};
